import React from 'react';
import { PrimePill } from './PrimePill';
import { DiamondIcon, Body } from '@edreamsodigeo/prisma-design-system';

export const PrimeLogoPill = () => {
  return (
    <PrimePill
      type="brand"
      icon={<DiamondIcon color="brandSecondary" size="tiny" />}
    >
      Prime
    </PrimePill>
  );
};

export const PrimeDayPill = () => {
  return (
    <PrimePill type="promotional">
      <Body type="xSmall" weight="medium">
        prime day pill
      </Body>
    </PrimePill>
  );
};
